// TODO - Rename this file to fireAppLaunchCustom
import { Linking } from "react-native";
import { APPLINK_PREFIX, APPLINK_URI_SCHEME } from "@navigation";
import analytics from "@services/analytics";
import { getApplinkData } from "@services/api";
import { getRefererData } from "@utils/PlayReferrer";
import { generateLinkParams } from "@utils/URL";
import URLParse from "url-parse";
import { OTHER_EVENTS } from "../constants/analyticsEventsCT";

let LOGGED_APP_LAUNCHED_CUSTOM = false;

const logAppLaunchCustom = async () => {
  const NativeLinking = Linking;
  let url = await NativeLinking.getInitialURL();
  let searchParams;
  let isApplink;

  if (url?.startsWith(APPLINK_URI_SCHEME)) {
    url = url.replace(APPLINK_URI_SCHEME, "");
  }

  let cleanUrl = url;

  if (url) {
    try {
      cleanUrl = decodeURIComponent(decodeURIComponent(url));
      searchParams = generateLinkParams(cleanUrl).getAll();
    } catch (e) {}
    if (url?.startsWith(APPLINK_PREFIX)) {
      const parsedUrl = URLParse(url) || {};
      const APPLINKS_HASH_LENGTH = 12;
      const hash = parsedUrl?.pathname?.replace("/", "");
      if (hash?.length === APPLINKS_HASH_LENGTH) {
        isApplink = true;
      }
      // We only fetch applink data when the deep link doesn't have a utm_source and is an applink
      if (isApplink && hash && !searchParams?.utm_source) {
        try {
          const { data: { data: { utm } = {} } = {} } =
            (await getApplinkData(hash)) || {};
          searchParams = { ...searchParams, ...utm };
        } catch (e) {
          console.log(e);
        }
      }
    }
  } else {
    let play_referrer;
    try {
      ({ installReferrer: play_referrer } = await getRefererData());
      searchParams = generateLinkParams(play_referrer).getAll();
    } catch (e) {
      console.log(e);
    }
    if (play_referrer?.includes("hash")) {
      isApplink = true;
    }
  }

  const utmData = { ...searchParams, url: cleanUrl };

  if (isApplink) {
    utmData.utm_source = utmData.utm_source || "applinks";
  }

  if (!LOGGED_APP_LAUNCHED_CUSTOM) {
    analytics.trackEvent(OTHER_EVENTS.APP_LAUNCHED_CUSTOM, utmData);
    LOGGED_APP_LAUNCHED_CUSTOM = true;
  }
};

export { logAppLaunchCustom };
